export const SUPER_USER = 'dima@saldvin.com';
export const VACATION_HOURS = 144;

export const VACATION_HOURS_INDIVIDUAL = {
  [SUPER_USER]: 160,
  'max.halochkin@saldvin.com': 160,
  'andrii.driahlin@saldvin.com': 160,
};

export const PROJECT_TYPES = {
  WORK: 'WORK',
  ILLNESS: 'ILLNESS',
  VACATION: 'VACATION',
  TIME_OFF: 'TIME_OFF',
  HOLIDAY: 'HOLIDAY',
};

export const TIME_OFF_PROJECT = { value: 'TimeOff', label: 'Time Off', type: PROJECT_TYPES.TIME_OFF };

export const PROJECTS = [
  { value: 'TT', label: 'Trading Technologies', type: PROJECT_TYPES.WORK },
  { value: 'Saldvin', label: 'Saldvin', type: PROJECT_TYPES.WORK },
  { value: 'TickState', label: 'TickState', type: PROJECT_TYPES.WORK },
  TIME_OFF_PROJECT,
];
